"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * ForecastChangeSupplierAgreementDTO converter.
 * @author Adam Drda
 */


var ForecastChangeSupplierAgreementDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ForecastChangeSupplierAgreementDTOConverter, _DataObjectConverter_);

  function ForecastChangeSupplierAgreementDTOConverter() {
    _classCallCheck(this, ForecastChangeSupplierAgreementDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ForecastChangeSupplierAgreementDTOConverter).apply(this, arguments));
  }

  return ForecastChangeSupplierAgreementDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ForecastChangeSupplierAgreementDTOConverter = ForecastChangeSupplierAgreementDTOConverter;